// extracted by mini-css-extract-plugin
export var highlightDark = "text-highlight--highlight-dark--ee5d0";
export var highlightLight = "text-highlight--highlight-light--ba2d4";